import { useState } from 'react';
import { useHeroData, type PropsElement } from '@/hero/data';
import { useSelectionStore, type Selection } from '@/state/selection';
import { RulesCard } from '../rules/Card';
import { useAssistantStore } from './state';

const TABS = ['ask', 'raw', 'rules'] as const;

export function AskAboutCard({
  selection,
  element,
}: {
  selection: Selection;
  element: PropsElement | undefined;
}) {
  const [tab, setTab] = useState<(typeof TABS)[number]>('ask');
  const ask = useAssistantStore((s) => s.ask);
  const select = useSelectionStore((s) => s.select);
  const line = useHeroData((s) => s.data?.raw[selection.expressID]);
  const name = element?.name ?? `#${selection.expressID}`;
  return (
    <div className="card-ask">
      <div className="qty-bar" role="tablist">
        {TABS.map((t) => (
          <button
            key={t}
            type="button"
            role="tab"
            aria-selected={tab === t}
            aria-pressed={tab === t}
            onClick={() => setTab(t)}
          >
            {t}
          </button>
        ))}
      </div>
      {tab === 'ask' && (
        <button
          type="button"
          onClick={() => {
            ask(
              `Explain element #${selection.expressID} (${name.slice(0, 50)}): its material, quantities and what is next to it.`,
            );
            select(null);
          }}
        >
          Ask the model about this
        </button>
      )}
      {tab === 'raw' && (
        <pre className={line ? 'code step' : 'code step muted'}>
          {line ? highlightStep(line) : 'No STEP line shipped for this element.'}
        </pre>
      )}
      {tab === 'rules' && <RulesCard selection={selection} element={element} />}
    </div>
  );
}

function highlightStep(line: string) {
  const parts = line.split(/('[^']*'|#\d+|\$|\.[A-Z_]+\.)/g);
  return parts.map((p, i) => {
    if (!p) return null;
    const kind = p.startsWith("'")
      ? 'str'
      : p.startsWith('#')
        ? 'ref'
        : p === '$'
          ? 'nil'
          : p.startsWith('.')
            ? 'enum'
            : undefined;
    return (
      <span key={i} className={kind}>
        {p}
      </span>
    );
  });
}
